import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  settheGrievanceEMPApproveretrieveActions,
  SetTheGrievaceApprovalActions,
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import "../../../StyleSheet/MainComponent/LeavePermission/LeavePermission.scss";


const GrievaceApprove = (props) => {
  const { currentPage, setShow, show, EditId, selectVal , data , white_collar, to_date , from_date , search } = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [descpErr, setdeserr] = useState("");
  const initialState = {
    status: "",

    purpose: "",
    grievance_type: "",
    user_id: "",
    user_name: "",
    description: "",
  };
  const [Data, setDatas] = useState(initialState);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  useEffect(() => {
    const payload = {
      EditID: EditId,
    };

    dispatch(settheGrievanceEMPApproveretrieveActions(payload));
  }, []);
  useEffect(() => {
    var grievance_typeRetrie = "";
    console.log(state, "692369r7dujsef");
    if (
      state.GrievanceApproveretriveCall.GrievanceRETEVEApprove != undefined &&
      state.GrievanceApproveretriveCall.GrievanceRETEVEApprove.grievance_type !=
        undefined
      //   &&
      //   state.GrievanceApproveretriveCall.GrievanceRETEVEApprove.grievance_type
      //   .grievance_type != null  &&
      // state.GrievanceApproveretriveCall.GrievanceRETEVEApprove.grievance_type
      //   .grievance_type.grievance_type != null &&
      // state.GrievanceApproveretriveCall.GrievanceRETEVEApprove.grievance_type
      //   .grievance_type.grievance_type != undefined
    ) {
      grievance_typeRetrie =
        state.GrievanceApproveretriveCall.GrievanceRETEVEApprove.grievance_type
          .grievance_type;
      console.log(
        grievance_typeRetrie,
        "grievance_typeRetrie",
        state.GrievanceApproveretriveCall.GrievanceRETEVEApprove
      );
    }

    if (
      state.GrievanceApproveretriveCall.GrievanceRETEVEApprove.id != undefined
    ) {
      setDatas({
        ...Data,
        grievance_type: grievance_typeRetrie,
        status: state.GrievanceApproveretriveCall.GrievanceRETEVEApprove.status,

        user_name:
          state.GrievanceApproveretriveCall.GrievanceRETEVEApprove.user_id
            .first_name,

        description:
          state.GrievanceApproveretriveCall.GrievanceRETEVEApprove
            .reason_for_decline,
      });
    }
  }, [state.GrievanceApproveretriveCall.GrievanceRETEVEApprove]);

  const HandleChanges = (e) => {
    setDatas({
      ...Data,
      status: e.target.value,
    });
  };
  const HandleDecriptions = (e) => {
    setDatas({
      ...Data,
      description: e.target.value,
    });
    setdeserr("");
  };

  const handleClose = () => {
    setShow(false);
  };
  const HandleClick = () => {
    const payload = {
      status: Data.status.toLowerCase(),
      description: Data.description,
      EditId: EditId,
      currentPage: currentPage,
      selectVal: selectVal,
      data:data,
      white_collar:white_collar,
      to_date:to_date, 
      from_date:from_date, 
      search:search
    };
    dispatch(SetTheGrievaceApprovalActions(payload, props.setShow()));
  };
  const Options = [
    {
      id: 1,
      Status: "Approved",
    },
    {
      id: 2,
      Status: "Decline",
    },
    {
      id: 3,
      Status: "Pending",
    },
  ];
  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Grievance Request </span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.user_name}
                            name="last_name"
                            readOnly
                          />
                        </div>
                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Grievance type
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="name"
                            value={Data.grievance_type}
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Status
                          </label>
                          <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            onChange={HandleChanges}
                            /// value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  Data.status.toLowerCase() ==
                                  item.Status.toLowerCase()
                                }
                                value={item.Status}
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select>
                        </div>
                    

                      {Data.status.toLowerCase() == "decline" ? (
                        <>
                          <div
                            className="col-sm-3 mt-3"
                            style={{ width: "700px" }}
                          >
                            <label for="validationCustom01" class="form-label">
                              Reason for decline
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              autocomplete="off"
                              name="description"
                              value={Data.description}
                              onChange={HandleDecriptions}
                            />
                            <p style={{ color: "red" }}>{descpErr}</p>
                          </div>
                        </>
                      ) : null}
                        </div>
                    </div>

                    <div className="UserButtons">
                      <button
                        class="btn  SaveBtn"
                        type="submit"
                         disabled={Data.status == state.GrievanceApproveretriveCall.GrievanceRETEVEApprove.status ? true : false}
                        onClick={(e) => {
                          HandleClick(e);
                        }}
                      >
                        Submit
                      </button>
                      <button
                        class="btn CancelBtn"
                        onClick={(e) => handleClose(e)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GrievaceApprove;
